import { createSelector } from 'reselect'
import { variation } from './helpers'

const getRoot = state => state.get('experiment')

export const getLoaded = state => getRoot(state).get('loaded')

const makeHasExperiementVariation = (experimentName, experimentVariation) =>
  createSelector(getLoaded, (isLoaded) =>
    isLoaded && variation(experimentName) === experimentVariation)

export const makehasNonBlacklistedGate = experimentName => makeHasExperiementVariation(experimentName, 'on')



// WEBPACK FOOTER //
// ./src/scripts/app/modules/experiment/selectors.js